import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/blog/list/index.ts